module.exports = __webpack_public_path__ + "img/bg.5fb0ed71.png";